import { ProjectData } from 'ontime-types';

export const projectDataPlaceholder: ProjectData = {
  title: '',
  description: '',
  url: '',
  info: '',
  logo: null,
  custom: [],
};
